<!-- 商品管理 V2 - 编辑商品管理番号弹窗 -->
<template>
  <el-dialog
    :title="$t('message.productV2EditManagementCode')"
    :visible.sync="visible"
    width="480px"
    append-to-body
    custom-class="edit-client-sku-dialog"
  >
    <el-form label-width="110px" @submit.native.prevent>
      <el-form-item :label="$t('message.managementDesignation')">
        <el-input
          ref="clientSkuInput"
          v-model="client_sku_code"
          maxlength="100"
          @keyup.enter.native="save"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" :loading="saving" @click="save">{{ $t('message.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 列表页编辑 client_sku_code（商品管理番号）
 * 通过 updateClientSkuCode 接口保存
 */
export default {
  name: 'EditClientSkuDialog',
  data() {
    return {
      visible: false, // 弹窗显隐
      saving: false, // 保存中
      item: {}, // 当前操作的列表行
      client_sku_code: '' // 编辑中的管理番号
    }
  },
  methods: {
    // 打开弹窗并聚焦输入框
    open(item) {
      this.item = item
      this.client_sku_code = item.client_sku_code
      this.visible = true
      this.$nextTick(() => this.$refs.clientSkuInput.focus())
    },
    // 校验后提交管理番号
    async save() {
      const client_sku_code = this.client_sku_code.trim()
      if (!client_sku_code) {
        return this.$message.error(this.$t('message.productV2EnterManagementCode'))
      }
      this.saving = true
      try {
        const res = await this.$api.productManagementApi.updateClientSkuCode({
          user_id: this.item.user_id,
          sys_code: this.item.sys_code,
          client_sku_code
        })
        this.$message.success(res.msg)
        this.visible = false
        this.$emit('success')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss">
.edit-client-sku-dialog .el-dialog__body { padding: 24px 28px 8px; }
</style>
